import Api from './Api'

export default {
    getBuscarEspecialistas(lat, lng, page, type) {
        return Api().get(`/socios?lat=${lat}&lng=${lng}&page=${page}&type=${type}`);
    }
}